<script>
    import {links, navigate} from "svelte-routing";
    import ListViewItemComponent from "./ListViewItemComponent.svelte";
    import DetailVievItemComponent from "./DetailVievItemComponent.svelte";
    import SvelteSeo from "svelte-seo";
    import {decode} from "html-entities";

    export let config;
    export let cinfo;

    $ : cid = cinfo.match(/-c-(\d)+/g)[0].split(/c-/)[1];
    $ : contentItem = loadContentItem(cid);
    $ : cname = "";

    function loadContentItem(id) {
        return fetch(config.model_root + 'shared/contents/load_content_details.php?cid=' + id, {
            method: "GET"
        })
            .then(response => response.json())
            .then((data) => {
                cname = data[0].cname;
                return data;
            });
    }


</script>

<svelte:head>
    <title>{decode(cname)}</title>
</svelte:head>

<SvelteSeo
        title="{cname}"
        description="Ernst Pagels Garten in Leer ist ein Schaugarten für Pagels Züchtungen und ein offener Mehrgenerationengarten (Garten für Jeden), der Einrichtungen als Kooperationspartner sowie der interessierten Öffentlichkeit zur Verfügung steht."
        keywords="pagels-garten, Pagels Garten, Leer, Ernst Pagels, Ernst-Pagels Garten, Ernst Pagels Stauden, Staudenpapst, Staudenmarkt, Schaugarten, miscantus, Pagels Leer, Pagels-Garten, Karl Förster"
        openGraph={{
            title: `${cname}`,
            description: 'Ernst Pagels Garten in Leer ist ein Schaugarten für Pagels Züchtungen und ein offener Mehrgenerationengarten (Garten für Jeden), der Einrichtungen als Kooperationspartner sowie der interessierten Öffentlichkeit zur Verfügung steht.',
            url: `https://www.pagels-garten.de/content/${cinfo}`,
            type: 'website',
            images: [
              {
                url: 'https://pagels-garten.maleck.org/images/_MG_8331%20header.jpg',
                width: 2449,
                height: 1632,
                alt: 'Ernst Pagels Garten in Leer'
              }
             ]
          }}
/>

<div class="container site-content" use:links>
    <div class="row">

        <div class="col">
            <div class="site-section px-4 py-4 rounded">

                {#await contentItem}
                    <p class="alert alert-light">
                        <i class="fas fa-circle-notch fa-spin me-1"></i> Lade Inhalt...
                    </p>
                {:then items}

                    {#each items as content}

                        <DetailVievItemComponent {config} {content} />

                    {/each}

                {:catch error}
                    {navigate("/not-found", { replace: false })}
<!--                    <p style="color: red">{error.message}</p>-->
                {/await}

            </div>
        </div>
    </div>
</div>

<style>

    /* .site-content and .site-section see MenuItemComponent */

</style>
